import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Alert } from 'react-bootstrap';
import { translate } from "react-i18next";


class WarningInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      warning: this.props.warning
  };
  }
  render() {
    const { t } = this.props;
    return (<Alert variant={this.state.warning ? this.state.warning.cssClass : "light" } >
      {this.state.warning.description}
      {this.state.warning.link ?
          <a href={this.state.warning.link} target="_blank" className="mr-2 ml-2">{t("more")}</a>
          :
          ''
      }
     
     
    </Alert>

    );
  }

}
export default translate("translations")(WarningInfo);